module.exports = __webpack_public_path__ + "static/assets/0881d29f72e391c27e342e6c0bc310fa.svg";